export const loaderJson = {
    v: '5.7.4',
    fr: 30,
    ip: 0,
    op: 456,
    w: 400,
    h: 400,
    nm: 'Gesamtkomposition Final',
    ddd: 0,
    assets: [
        {
            id: 'comp_0',
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: 'SEW_Bewegbilder_Umrichter_2D Konturen',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [299.856, 86.277],
                                                [299.856, 97.422],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 1',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-25.052, 5.427],
                                                [-25.052, -6.573],
                                                [24.948, -6.573],
                                                [25.051, 6.573],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [293.052, 92.573], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 2',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 2,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [296, 286], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 3',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 3,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [308, 286], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 4',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 4,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [284, 286], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 5',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 5,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [296, 274], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 6',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 6,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [308, 274], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 7',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 7,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [284, 274], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 8',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 8,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [296, 262], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 9',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 9,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [308, 262], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 10',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 10,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [284, 262], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 11',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 11,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [296, 250], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 12',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 12,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [308, 250], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 13',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 13,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [284, 250], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 14',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 14,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [296, 238], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 15',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 15,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [308, 238], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 16',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 16,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [284, 238], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 17',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 17,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [296, 226], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 18',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 18,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [308, 226], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 19',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 19,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [284, 226], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 20',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 20,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [296, 214], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 21',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 21,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [308, 214], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 22',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 22,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [284, 214], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 23',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 23,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [118, 254.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 24',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 24,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [130, 254.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 25',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 25,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [106, 254.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 26',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 26,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [118, 242.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 27',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 27,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [130, 242.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 28',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 28,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [106, 242.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 29',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 29,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [118, 230.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 30',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 30,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [130, 230.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 31',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 31,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [106, 230.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 32',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 32,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [118, 214.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 33',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 33,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [130, 214.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 34',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 34,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [106, 214.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 35',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 35,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [118, 202.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 36',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 36,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [130, 202.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 37',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 37,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [106, 202.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 38',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 38,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [118, 190.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 39',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 39,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [130, 190.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 40',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 40,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.209],
                                                [2.209, 0],
                                                [0, 2.209],
                                                [-2.209, 0],
                                            ],
                                            o: [
                                                [0, 2.209],
                                                [-2.209, 0],
                                                [0, -2.209],
                                                [2.209, 0],
                                            ],
                                            v: [
                                                [4, 0],
                                                [0, 4],
                                                [-4, 0],
                                                [0, -4],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [106, 190.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 41',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 41,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [0.108, 38.458],
                                                [-0.054, -34.958],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [313.946, 331.042], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 42',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 42,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [273.833, 204.02],
                                                [317.939, 204.02],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 43',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 43,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [16.017, 13.059],
                                                [-16.018, 13.059],
                                                [-16.018, -13.058],
                                                [16.017, -12.811],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [295.865, 186.941], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 44',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 44,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [18.922, -6.316],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-16.458, -5.697],
                                            ],
                                            v: [
                                                [-21.885, -62.884],
                                                [-22.053, 69.199],
                                                [22.052, 69.199],
                                                [22.052, -62.82],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [295.885, 226.884], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 45',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 45,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-7, -5.796],
                                                [7, -5.796],
                                                [7, 5.796],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [275, 155.796], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 46',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 46,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [268, 150],
                                                [268, 366],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 47',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 47,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [0.044, -30.829],
                                                [-0.044, 8.865],
                                                [0.044, 30.829],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [309.902, 130.73], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 48',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 48,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-34.058, 0.075],
                                                [34.059, -0.075],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [296.058, 139.925], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 49',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 49,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [31.065, -139.889],
                                                [30.891, 130.029],
                                                [14.934, 129.889],
                                                [14.934, 139.889],
                                                [-31.066, 139.889],
                                                [-31.066, 125.889],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [299.065, 240.112], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 51',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 51,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [-11.406, -4.871],
                                                [0, 0],
                                            ],
                                            o: [
                                                [10.766, -3.981],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-34, 2.485],
                                                [13.858, 2.386],
                                                [34, 2.485],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [296, 97.515], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 52',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 52,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-2.927, -133.01],
                                                [-2.927, 132.99],
                                                [2.927, 133.01],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [264.927, 233.01], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 53',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 53,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [16, 116],
                                                [-16, 116],
                                                [-16, -116],
                                                [16, -116],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [164, 192.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 54',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 54,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-0.092, -29.662],
                                                [0.092, 29.663],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [87.908, 300.338], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 55',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 55,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-22, 0.049],
                                                [22, -0.049],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [118, 180.049], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 56',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 56,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [-12, -4],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [12, -4],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-22, -62],
                                                [22, -62],
                                                [22, 66],
                                                [-22, 66],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [118, 200.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 57',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 57,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [88, 130],
                                                [140, 130],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 58',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 58,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [140, 64.099],
                                                [140, 130],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 59',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 59,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-0.092, 83.283],
                                                [-0.092, -55.375],
                                                [0.092, -83.283],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [87.908, 187.393], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 60',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 60,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-24, 0.049],
                                                [24, -0.049],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [164, 64.049], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 61',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 61,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [41, -5],
                                                [-41, -5],
                                                [-41, 5],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [135, 57.099], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 62',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 62,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [26, 0.055],
                                                [-26, -0.055],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [114, 104.055], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 63',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 63,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [-16, -5.879],
                                            ],
                                            o: [
                                                [18, -5.762],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-26, 2.939],
                                                [26, 2.939],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [114, 61.159], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 64',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 64,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [88, 64.099],
                                                [88, 104.099],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 65',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 65,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-11, -15.951],
                                                [3, -15.951],
                                                [3, 4.049],
                                                [11, 4.049],
                                                [11, 15.951],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [165, 48.049], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 66',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 66,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [50, -133],
                                                [50, 133],
                                                [-50, 133],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [138, 197], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 67',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 67,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [35.921, 10.049],
                                                [36.079, -3.939],
                                                [29.921, -3.951],
                                                [29.921, -18.049],
                                                [27.921, -18.049],
                                                [27.921, -22.049],
                                                [7.871, -22.049],
                                                [7.921, -10.049],
                                                [-4.079, -10.049],
                                                [-4.079, -22.049],
                                                [-24.079, -22.049],
                                                [-24.079, -8.049],
                                                [-36.079, -8.049],
                                                [-36.079, 22.049],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [124.079, 42.049], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 68',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 68,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-25.079, -0.055],
                                                [25.079, 0.055],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [135.079, 38.055], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 69',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 69,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [110, 38],
                                                [110, 52.099],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 70',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 70,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'tm',
                            s: { a: 0, k: 0, ix: 1 },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 0,
                                        s: [0],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 30,
                                        s: [100],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 50,
                                        s: [100],
                                    },
                                    { t: 70, s: [0] },
                                ],
                                ix: 2,
                            },
                            o: { a: 0, k: 0, ix: 3 },
                            m: 1,
                            ix: 71,
                            nm: 'Pfade trimmen 1',
                            mn: 'ADBE Vector Filter - Trim',
                            hd: false,
                        },
                    ],
                    ip: 0,
                    op: 75,
                    st: 0,
                    bm: 0,
                },
            ],
        },
        {
            id: 'comp_1',
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: 'SEW_Bewegbilder_MOVIdrive_2D Konturen',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [349.351, 229.864],
                                                [380, 229.864],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 3',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 3,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -4.386],
                                                [4.386, 0],
                                                [0, 4.386],
                                                [-4.386, 0],
                                            ],
                                            o: [
                                                [0, 4.386],
                                                [-4.386, 0],
                                                [0, -4.386],
                                                [4.386, 0],
                                            ],
                                            v: [
                                                [7.941, 0],
                                                [0, 7.941],
                                                [-7.941, 0],
                                                [0, -7.941],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 2, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [312.348, 135.765], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [142.121, 142.121], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 5',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 5,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-3.556, -2.37],
                                                [0, 0],
                                                [0, 0],
                                                [-2.647, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [2.647, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-39.082, -8.773],
                                                [-32.388, 1.815],
                                                [12.612, 1.815],
                                                [17.906, 9.756],
                                                [23.25, 9.756],
                                                [23.201, -0.832],
                                                [25.848, -3.479],
                                                [28.495, -0.832],
                                                [28.495, 7.109],
                                                [39.082, 7.109],
                                                [39.082, -9.755],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [340.917, 359.656], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 6',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 6,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [-2.647, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, -2.647],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-10.588, 5.294],
                                                [-10.588, -2.647],
                                                [-7.941, -5.294],
                                                [2.647, -5.294],
                                                [10.588, -2.647],
                                                [10.588, 5.294],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [321.765, 35.883], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 7',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 7,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [349.351, 202.5],
                                                [380, 202.5],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 8',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 8,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, -5.294],
                                                [0, 0],
                                                [-4.611, -14.173],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [3.333, 0.238],
                                                [0, 0],
                                                [-0.284, 5.072],
                                                [3.289, 10.107],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-44.018, -81.809],
                                                [31.365, -81.867],
                                                [36.509, -76.514],
                                                [36.509, 23.633],
                                                [40.728, 71.29],
                                                [33.862, 81.867],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [312.841, 269.014], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 9',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 9,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [331.422, 163.584],
                                                [337.422, 163.584],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 10',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 10,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [306.578, 163.584],
                                                [325.211, 163.584],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    d: [
                                        { n: 'd', nm: 'strich', v: { a: 0, k: 12.422, ix: 1 } },
                                        { n: 'g', nm: 'abstand', v: { a: 0, k: 12.422, ix: 2 } },
                                        { n: 'o', nm: 'versatz', v: { a: 0, k: 0, ix: 7 } },
                                    ],
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 11',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 11,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [288.157, 163.584],
                                                [294.157, 163.584],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 12',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 12,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [24.633, 17.416],
                                                [-24.633, 17.416],
                                                [-24.633, -17.416],
                                                [24.633, -17.416],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [312.789, 92.337], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 16',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 16,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, -5.294],
                                                [0, 0],
                                                [5.294, 0],
                                                [0, 0],
                                                [0, 5.295],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 2.647],
                                                [0, 0],
                                                [-5.294, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-30.763, -56.912],
                                                [30.763, -56.912],
                                                [36.057, -51.618],
                                                [36.057, 51.617],
                                                [30.763, 56.912],
                                                [-30.763, 56.912],
                                                [-36.057, 51.617],
                                                [-36.057, -36.814],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [312.822, 116.618], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 17',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 17,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [3.166, 12.666],
                                                [0, 0],
                                                [0, 0],
                                                [-0.209, 1.046],
                                                [0, 0],
                                                [0, 0],
                                                [0, -10.588],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [-3.591, -14.364],
                                                [0, 0],
                                                [0, 0],
                                                [0.209, -1.046],
                                                [0, 0],
                                                [10.588, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [55.633, 154.853],
                                                [-42.308, 154.853],
                                                [-52.043, 141.717],
                                                [-55.543, 104.559],
                                                [-55.543, -80.735],
                                                [-41.033, -145.666],
                                                [-37.014, -154.853],
                                                [45.045, -154.853],
                                                [55.633, -144.265],
                                                [55.62, 154.383],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [324.367, 196.029], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 18',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 18,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [158.269, 54.567],
                                                [158.269, 359.387],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 19',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 19,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [170.839, 54.567],
                                                [170.839, 359.387],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 20',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 20,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [0.141, -152.41],
                                                [-0.141, 152.41],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [183.268, 206.977], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 21',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 21,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [0.014, 12.808],
                                                [-0.014, -12.808],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [117.927, 41.604], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 22',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 22,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [126.844, 26.285],
                                                [126.844, 54.567],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 23',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 23,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [0.149, -14.064],
                                                [-0.148, 14.064],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [139.266, 40.348], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 24',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 24,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [151.984, 26.285],
                                                [151.984, 51.425],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 25',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 25,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [164.554, 26.285],
                                                [164.554, 51.425],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 26',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 26,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [177.124, 26.285],
                                                [177.124, 51.425],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 27',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 27,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [189.694, 26.285],
                                                [189.694, 51.425],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 28',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 28,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [202.264, 26.285],
                                                [202.264, 51.425],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 29',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 29,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [202.264, 51.425],
                                                [220, 51.425],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 30',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 30,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [220, 20],
                                                [220, 380],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 31',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 31,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [2.717, 0],
                                                [3.143, 0],
                                                [3.143, 0],
                                                [3.143, 0],
                                                [3.143, 0],
                                                [3.143, 0],
                                                [3.143, 0],
                                                [3.142, 0],
                                                [3.142, 0],
                                                [3.142, 0],
                                                [3.142, 0],
                                                [3.142, 0],
                                            ],
                                            o: [
                                                [-2.081, -0.636],
                                                [-3.142, 0],
                                                [-3.142, 0],
                                                [-3.142, 0],
                                                [-3.142, 0],
                                                [-3.142, 0],
                                                [-3.142, 0],
                                                [-3.142, 0],
                                                [-3.143, 0],
                                                [-3.143, 0],
                                                [-3.143, 0],
                                                [-3.143, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [37.15, 1.414],
                                                [31.984, -1.571],
                                                [25.699, 1.571],
                                                [19.414, -1.571],
                                                [13.129, 1.571],
                                                [6.844, -1.571],
                                                [0.559, 1.571],
                                                [-5.726, -1.571],
                                                [-12.01, 1.571],
                                                [-18.295, -1.571],
                                                [-24.58, 1.571],
                                                [-30.865, -1.571],
                                                [-37.15, 1.571],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [182.849, 357.816], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 32',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 32,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [2.717, 0],
                                                [3.142, 0],
                                                [3.142, 0],
                                                [3.142, 0],
                                                [3.142, 0],
                                                [3.142, 0],
                                                [3.142, 0],
                                                [3.142, 0],
                                                [3.143, 0],
                                                [3.143, 0],
                                                [3.143, 0],
                                                [3.143, 0],
                                                [3.143, 0],
                                                [3.143, 0],
                                                [3.143, 0],
                                                [3.143, 0],
                                                [3.142, 0],
                                            ],
                                            o: [
                                                [-2.081, -0.636],
                                                [-3.143, 0],
                                                [-3.143, 0],
                                                [-3.143, 0],
                                                [-3.143, 0],
                                                [-3.143, 0],
                                                [-3.143, 0],
                                                [-3.143, 0],
                                                [-3.142, 0],
                                                [-3.142, 0],
                                                [-3.142, 0],
                                                [-3.142, 0],
                                                [-3.142, 0],
                                                [-3.142, 0],
                                                [-3.142, 0],
                                                [-3.142, 0],
                                                [-3.142, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [54.434, 1.414],
                                                [49.268, -1.571],
                                                [42.983, 1.571],
                                                [36.698, -1.571],
                                                [30.413, 1.571],
                                                [24.128, -1.571],
                                                [17.843, 1.571],
                                                [11.558, -1.571],
                                                [5.273, 1.571],
                                                [-1.012, -1.571],
                                                [-7.297, 1.571],
                                                [-13.582, -1.571],
                                                [-19.867, 1.571],
                                                [-26.152, -1.571],
                                                [-32.437, 1.571],
                                                [-38.722, -1.571],
                                                [-45.007, 1.571],
                                                [-54.434, -1.571],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [165.566, 27.856], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 33',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 33,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [-5.294, 0],
                                                [0, 0],
                                                [0, -4.601],
                                            ],
                                            o: [
                                                [0, -6.285],
                                                [0, 0],
                                                [7.956, -0.282],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-28.978, 5.141],
                                                [-21.478, -4.859],
                                                [21.022, -4.859],
                                                [28.522, 5.141],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [48.978, 194.859], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 37',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 37,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [77.5, 167.5],
                                                [77.5, 316.471],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 38',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 38,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-25.175, 48.61],
                                                [-25.105, -48.61],
                                                [25.175, -48.61],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [57.675, 118.89], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 39',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 39,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [31.425, -58.038],
                                                [31.075, 58.038],
                                                [-31.425, 58.038],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [51.425, 109.462], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 40',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 40,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [33.235, 316.471],
                                                [220, 316.471],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 41',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 41,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [94.118, 51.765],
                                                [94.118, 316.471],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 42',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 42,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [1.038, -3.562],
                                                [0, 0],
                                                [-9.427, 0],
                                                [0, -6.285],
                                                [0, 0],
                                                [-2.214, -1.314],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, -15.712],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0.311, 10.016],
                                                [0, 0],
                                                [0, 0],
                                                [0, 1.972],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [32.445, -137.76],
                                                [21.997, -153.981],
                                                [-50.279, -153.981],
                                                [-62.85, -113.13],
                                                [-62.85, 84.847],
                                                [-49.615, 111.064],
                                                [-57.555, 116.358],
                                                [-57.555, 142.829],
                                                [-52.262, 153.416],
                                                [62.85, 153.981],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [82.85, 205.407], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 43',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 43,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-6.216, -0.061],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [6.285, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-74.86, 15.712],
                                                [-74.86, -3.142],
                                                [-37.15, -3.142],
                                                [-30.934, -15.651],
                                                [74.86, -15.712],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [145.14, 35.712], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 44',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 44,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-3.113, 5.513],
                                                [-9.159, 0.106],
                                                [-3.142, 0],
                                                [-3.142, 0],
                                                [-3.143, 0],
                                                [-3.143, 0],
                                                [-3.143, 0],
                                                [-3.143, 0],
                                                [-3.143, 0],
                                                [-3.143, 0],
                                                [-3.143, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, -4.286],
                                                [0, 0],
                                                [7.651, -0.089],
                                                [3.143, 0],
                                                [3.139, 0],
                                                [3.142, 0],
                                                [3.142, 0],
                                                [3.142, 0],
                                                [3.142, 0],
                                                [3.142, 0],
                                                [3.142, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [52.586, 164.288],
                                                [-52.12, 164.288],
                                                [-52.12, -148.065],
                                                [-49.473, -161.301],
                                                [-25.649, -161.301],
                                                [-15.43, -164.288],
                                                [-9.145, -161.146],
                                                [-2.86, -164.288],
                                                [3.425, -161.146],
                                                [9.71, -164.288],
                                                [15.995, -161.146],
                                                [22.28, -164.288],
                                                [28.565, -161.146],
                                                [34.85, -164.288],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [167.414, 215.712], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 45',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 45,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [195.979, 54.567],
                                                [195.979, 359.387],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [0.988235353956, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 46',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 46,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'tm',
                            s: { a: 0, k: 0, ix: 1 },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 0,
                                        s: [0],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 35,
                                        s: [100],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 55,
                                        s: [100],
                                    },
                                    { t: 80, s: [0] },
                                ],
                                ix: 2,
                            },
                            o: { a: 0, k: 0, ix: 3 },
                            m: 1,
                            ix: 47,
                            nm: 'Pfade trimmen 1',
                            mn: 'ADBE Vector Filter - Trim',
                            hd: false,
                        },
                    ],
                    ip: 0,
                    op: 85,
                    st: 0,
                    bm: 0,
                },
            ],
        },
        {
            id: 'comp_2',
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: 'SEW_Bewegbilder_MOMVIMOadvanced_2D Konturen',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [99.993, 330],
                                                [125, 330],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 1',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [4.973, 5.033],
                                                [-4.974, -5.033],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [229.973, 335.033], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 2',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 2,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [2.761, 0],
                                                [0, 0],
                                                [0, 2.761],
                                                [-2.761, 0],
                                                [0, 0],
                                                [0, -2.761],
                                            ],
                                            o: [
                                                [0, 0],
                                                [-2.761, 0],
                                                [0, -2.761],
                                                [0, 0],
                                                [2.761, 0],
                                                [0, 2.761],
                                            ],
                                            v: [
                                                [15, 5],
                                                [-15, 5],
                                                [-20, 0],
                                                [-15, -5],
                                                [15, -5],
                                                [20, 0],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [340, 305], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 3',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 3,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [210, 330],
                                                [270, 330],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 4',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 4,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [265, 300],
                                                [100, 300],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 5',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 5,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-82.5, 0.043],
                                                [-2.379, -0.044],
                                                [82.5, 0.043],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [182.5, 210.044], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 6',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 6,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [80.14, 205],
                                                [80.14, 330],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 7',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 7,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [70.232, 205],
                                                [70.232, 330],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 8',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 8,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [265, 320],
                                                [265, 189.695],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 9',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 9,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -4.202],
                                                [4.202, 0],
                                                [0, 4.202],
                                                [-4.202, 0],
                                            ],
                                            o: [
                                                [0, 4.202],
                                                [-4.202, 0],
                                                [0, -4.202],
                                                [4.202, 0],
                                            ],
                                            v: [
                                                [7.608, 0],
                                                [0, 7.608],
                                                [-7.608, 0],
                                                [0, -7.608],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [227.608, 147.608], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 10',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 10,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -4.202],
                                                [4.202, 0],
                                                [0, 4.202],
                                                [-4.202, 0],
                                            ],
                                            o: [
                                                [0, 4.202],
                                                [-4.202, 0],
                                                [0, -4.202],
                                                [4.202, 0],
                                            ],
                                            v: [
                                                [7.608, 0],
                                                [0, 7.608],
                                                [-7.608, 0],
                                                [0, -7.608],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [252.608, 147.608], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 11',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 11,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -6.904],
                                                [6.904, 0],
                                                [0, 6.904],
                                                [-6.904, 0],
                                            ],
                                            o: [
                                                [0, 6.904],
                                                [-6.904, 0],
                                                [0, -6.904],
                                                [6.904, 0],
                                            ],
                                            v: [
                                                [12.5, 0],
                                                [0, 12.5],
                                                [-12.5, 0],
                                                [0, -12.5],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [282.5, 152.5], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 12',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 12,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 3.289],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-3.295, -0.009],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [3.288, -0.035],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0.018, 3.295],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-67.5, 10],
                                                [-48.436, 9.744],
                                                [-42.5, 3.744],
                                                [-42.5, -20],
                                                [42.333, -19.879],
                                                [42.467, 4.049],
                                                [48.451, 10.016],
                                                [67.447, 10.066],
                                                [67.5, 20],
                                                [-67.491, 20],
                                                [-67.498, 10],
                                                [-57.5, 0],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [167.5, 330], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 13',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 13,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [20.012, 10],
                                                [-20.012, 9.926],
                                                [-20.012, -4.962],
                                                [-15.018, -4.962],
                                                [-14.967, -9.911],
                                                [20.012, -10],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [39.987, 270], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 14',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 14,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [-5.523, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, -5.515],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-5.515, 0.01],
                                                [0, 0],
                                                [0, 5.523],
                                            ],
                                            v: [
                                                [-10, 62.537],
                                                [19.993, 62.537],
                                                [20, -62.537],
                                                [-10.019, -62.481],
                                                [-20, -52.482],
                                                [-20, 52.537],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [80, 267.463], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 15',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 15,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, -2.209],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [-2.209, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [45, -9.963],
                                                [45, 0.037],
                                                [-41, 0.037],
                                                [-45, 4.037],
                                                [-45, 9.963],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [145, 194.963], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 16',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 16,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-12.5, 0.001],
                                                [12.5, -0.001],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [112.5, 320.017], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 17',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 17,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-27.5, 0.003],
                                                [27.5, -0.003],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [237.5, 320.003], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 18',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 18,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [262.057, 185],
                                                [206.355, 185],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 19',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 19,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [1.12, 13.293],
                                            ],
                                            o: [
                                                [-1.724, -2.806],
                                                [0, 0],
                                            ],
                                            v: [
                                                [4.227, 10.74],
                                                [-4.227, -10.739],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [202.129, 174.26], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 20',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 20,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [2.057, 44.917],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [5, 25],
                                                [-5, -25],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [206.355, 155], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 21',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 21,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, -4.404],
                                                [-5, -5],
                                                [0, 0],
                                                [-2.064, 3.303],
                                                [0, 0],
                                                [-4.795, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-3.314, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 4.404],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [5.002, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, -3.314],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-85, -30],
                                                [-85, -20],
                                                [-80, -15],
                                                [-75, 25],
                                                [-58.645, 25],
                                                [-53.645, 20],
                                                [-3.645, 20],
                                                [1.355, 30],
                                                [65, 30],
                                                [70, 20],
                                                [75, 15],
                                                [75, -14],
                                                [81, -20],
                                                [85, -20],
                                                [85, -30],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [265, 160], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 22',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 22,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [80, 37.5],
                                                [80, -32.5],
                                                [75, -32.5],
                                                [70, -37.5],
                                                [60, -37.5],
                                                [55.165, -32.892],
                                                [-54.835, -32.892],
                                                [-60, -37.5],
                                                [-70, -37.5],
                                                [-75, -32.5],
                                                [-80, -32.5],
                                                [-80, 37.5],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [260, 92.5], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 23',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 23,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [-3.854, -1.115],
                                                [-8.477, -16.293],
                                                [-0.156, -10.353],
                                                [0, -4.286],
                                                [2.533, -6.117],
                                                [18.33, -3.853],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [3.853, 1.116],
                                                [8.477, 16.294],
                                                [0.147, 9.736],
                                                [0, 4.286],
                                                [-2.14, 5.168],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [7.5, -69.884],
                                                [30.271, -69.002],
                                                [48.766, -50.492],
                                                [57.353, -24.62],
                                                [57.353, 32.507],
                                                [48.085, 57.708],
                                                [23.855, 70.116],
                                                [-52.5, 70.116],
                                                [-57.5, 60.116],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [322.5, 259.884], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 24',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 24,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -6.892],
                                                [6.892, 0],
                                                [0, 6.892],
                                                [-6.893, 0],
                                            ],
                                            o: [
                                                [0, 6.892],
                                                [-6.893, 0],
                                                [0, -6.892],
                                                [6.892, 0],
                                            ],
                                            v: [
                                                [12.479, 0],
                                                [0, 12.479],
                                                [-12.48, 0],
                                                [0, -12.479],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [317.521, 152.521], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 25',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 25,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'tm',
                            s: { a: 0, k: 0, ix: 1 },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 0,
                                        s: [0],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 30,
                                        s: [100],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 50,
                                        s: [100],
                                    },
                                    { t: 70, s: [0] },
                                ],
                                ix: 2,
                            },
                            o: { a: 0, k: 0, ix: 3 },
                            m: 1,
                            ix: 26,
                            nm: 'Pfade trimmen 1',
                            mn: 'ADBE Vector Filter - Trim',
                            hd: false,
                        },
                    ],
                    ip: 0,
                    op: 75,
                    st: 0,
                    bm: 0,
                },
            ],
        },
        {
            id: 'comp_3',
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: 'SEW_Bewegbilder_IG_2D Konturen',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -1.365],
                                                [0, 0],
                                                [-4.418, 0],
                                                [0, 0],
                                                [0, 4.418],
                                                [0, 0],
                                                [0, 0],
                                                [13.154, -8.2],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 4.418],
                                                [0, 0],
                                                [4.418, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-4.909, 0],
                                                [-4.904, 3.057],
                                            ],
                                            v: [
                                                [-27.212, 5.69],
                                                [-27.212, 17],
                                                [-19.212, 25],
                                                [19.884, 25],
                                                [27.884, 17],
                                                [28.058, -25],
                                                [12.788, -25],
                                                [-23.154, -5],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [322.212, 250], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 1',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 3.808],
                                                [0, 0],
                                                [-4.418, 0],
                                                [0, 0],
                                                [0, -4.418],
                                                [0, 0],
                                                [0, 0],
                                                [1.215, 0.245],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, -4.418],
                                                [0, 0],
                                                [4.418, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-5.566, -14.245],
                                                [-3.733, -0.754],
                                            ],
                                            v: [
                                                [-30, -5.69],
                                                [-30, -17],
                                                [-22, -25],
                                                [22, -25],
                                                [30, -17],
                                                [30, 25],
                                                [10, 25],
                                                [-23.575, 2.15],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [325, 130], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 2',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 2,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [-18.896, 3.473],
                                                [0, 0],
                                                [4.418, 0],
                                                [0, 0],
                                                [0, -4.418],
                                                [0, 0],
                                                [-4.418, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, -4.418],
                                                [0, 0],
                                                [-4.418, 0],
                                                [0, 0],
                                                [0, 4.419],
                                                [0, 0],
                                                [6.83, -17.481],
                                            ],
                                            v: [
                                                [30, -4.076],
                                                [30, -22],
                                                [22, -30],
                                                [-22, -30],
                                                [-30, -22],
                                                [-30, 22],
                                                [-22, 30],
                                                [-11.233, 30],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [80, 135], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 3',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 3,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [8.386, 16.399],
                                                [0, 0],
                                                [0, -4.418],
                                                [0, 0],
                                                [-4.418, 0],
                                                [0, 0],
                                                [0, 4.418],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [-4.418, 0],
                                                [0, 0],
                                                [0, 4.418],
                                                [0, 0],
                                                [4.418, 0],
                                                [0, 0],
                                                [-19.232, -1.734],
                                            ],
                                            v: [
                                                [-13.985, -30],
                                                [-22, -30],
                                                [-30, -22],
                                                [-30, 22],
                                                [-22, 30],
                                                [22, 30],
                                                [30, 22],
                                                [30, -0.237],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [85, 240], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 4',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 4,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [18.552, 0],
                                                [0, -30.376],
                                                [-30.376, 0],
                                                [-9.962, 14.071],
                                            ],
                                            o: [
                                                [-9.962, -14.071],
                                                [-30.376, 0],
                                                [0, 30.375],
                                                [18.552, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [49.954, -31.734],
                                                [5.046, -55],
                                                [-49.954, 0],
                                                [5.046, 55],
                                                [49.954, 31.733],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [114.954, 185], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 5',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 5,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [19.33, 0],
                                                [0, 0],
                                                [0, 0],
                                                [10.742, 0],
                                                [8.144, -8.149],
                                                [0, 0],
                                                [-12.432, 0],
                                                [-7.737, 6.281],
                                                [0, 0],
                                                [0, 0],
                                                [0, 19.33],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [-7.737, -6.281],
                                                [-12.432, 0],
                                                [0, 0],
                                                [8.144, 8.149],
                                                [10.742, 0],
                                                [0, 0],
                                                [0, 0],
                                                [19.33, 0],
                                                [0, -19.33],
                                            ],
                                            v: [
                                                [42.5, -35],
                                                [-17.332, -35],
                                                [-17.332, -34.949],
                                                [-45.67, -45],
                                                [-77.5, -31.81],
                                                [-77.5, 31.81],
                                                [-45.67, 45],
                                                [-17.332, 34.949],
                                                [-17.332, 35],
                                                [42.5, 35],
                                                [77.5, 0],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [257.5, 185], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 6',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 6,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [2.75, 0],
                                                [0, 0],
                                                [0, 2.75],
                                                [-2.75, 0],
                                                [0, -2.75],
                                            ],
                                            o: [
                                                [0, 0],
                                                [-2.75, 0],
                                                [0, -2.75],
                                                [2.75, 0],
                                                [0, 2.75],
                                            ],
                                            v: [
                                                [0, 5],
                                                [0, 5],
                                                [-5, 0],
                                                [0, -5],
                                                [5, 0],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [365, 95], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 7',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 7,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [2.75, 0],
                                                [0, 0],
                                                [0, 2.75],
                                                [-2.75, 0],
                                                [0, -2.75],
                                            ],
                                            o: [
                                                [0, 0],
                                                [-2.75, 0],
                                                [0, -2.75],
                                                [2.75, 0],
                                                [0, 2.75],
                                            ],
                                            v: [
                                                [0, 5],
                                                [0, 5],
                                                [-5, 0],
                                                [0, -5],
                                                [5, 0],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [365, 265], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 8',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 8,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [2.75, 0],
                                                [0, 0],
                                                [0, 2.75],
                                                [-2.75, 0],
                                                [0, -2.75],
                                            ],
                                            o: [
                                                [0, 0],
                                                [-2.75, 0],
                                                [0, -2.75],
                                                [2.75, 0],
                                                [0, 2.75],
                                            ],
                                            v: [
                                                [0, 5],
                                                [0, 5],
                                                [-5, 0],
                                                [0, -5],
                                                [5, 0],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [45, 270], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 9',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 9,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [2.75, 0],
                                                [0, 0],
                                                [0, 2.75],
                                                [-2.75, 0],
                                                [0, -2.75],
                                            ],
                                            o: [
                                                [0, 0],
                                                [-2.75, 0],
                                                [0, -2.75],
                                                [2.75, 0],
                                                [0, 2.75],
                                            ],
                                            v: [
                                                [0, 5],
                                                [0, 5],
                                                [-5, 0],
                                                [0, -5],
                                                [5, 0],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [40, 105], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 10',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 10,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -2.761],
                                                [2.761, 0],
                                                [0, 2.761],
                                                [-2.761, 0],
                                            ],
                                            o: [
                                                [0, 2.761],
                                                [-2.761, 0],
                                                [0, -2.761],
                                                [2.761, 0],
                                            ],
                                            v: [
                                                [5, 0],
                                                [0, 5],
                                                [-5, 0],
                                                [0, -5],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [120, 185], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 11',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 11,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -11.046],
                                                [11.046, 0],
                                                [0, 11.046],
                                                [-11.046, 0],
                                            ],
                                            o: [
                                                [0, 11.046],
                                                [-11.046, 0],
                                                [0, -11.046],
                                                [11.046, 0],
                                            ],
                                            v: [
                                                [20, 0],
                                                [0, 20],
                                                [-20, 0],
                                                [0, -20],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [285, 185], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 12',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 12,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -11.046],
                                                [11.046, 0],
                                                [0, 11.046],
                                                [-11.046, 0],
                                            ],
                                            o: [
                                                [0, 11.046],
                                                [-11.046, 0],
                                                [0, -11.046],
                                                [11.046, 0],
                                            ],
                                            v: [
                                                [20, 0],
                                                [0, 20],
                                                [-20, 0],
                                                [0, -20],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [215, 185], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 13',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 13,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -11.046],
                                                [11.046, 0],
                                                [0, 11.046],
                                                [-11.046, 0],
                                            ],
                                            o: [
                                                [0, 11.046],
                                                [-11.046, 0],
                                                [0, -11.046],
                                                [11.046, 0],
                                            ],
                                            v: [
                                                [20, 0],
                                                [0, 20],
                                                [-20, 0],
                                                [0, -20],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [120, 185], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 14',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 14,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [2.455, -2.532],
                                                [0, 0],
                                                [3.257, -2.972],
                                                [0, 0],
                                                [2.817, -2.737],
                                                [0, 0],
                                                [3.211, -3.783],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [1.824, 1.519],
                                                [0, 0],
                                                [2.303, 1.782],
                                                [0, 0],
                                                [2.079, 2.416],
                                                [0, 0],
                                                [1.755, 1.49],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-1.493, -36.365],
                                                [-1.493, -31.477],
                                                [-1.152, -23.09],
                                                [-1.591, -13.957],
                                                [-1.494, -3.97],
                                                [-1.494, 3.826],
                                                [-1.424, 13.159],
                                                [-1.424, 22.281],
                                                [-1.763, 31.18],
                                                [-1.591, 36.365],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [31.763, 183.821], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 15',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 15,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-19.816, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [10, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [8.445, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-137.615, 24.819],
                                                [-72.495, 25.039],
                                                [-62.422, 35.002],
                                                [17.531, 34.973],
                                                [27.531, 24.973],
                                                [57.577, 25.039],
                                                [77.546, 35.071],
                                                [112.531, 34.973],
                                                [122.531, 24.973],
                                                [127.531, 24.973],
                                                [137.615, 14.911],
                                                [137.531, -35.027],
                                                [107.822, -35.071],
                                                [107.531, 34.973],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [242.469, 255.027], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 16',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 16,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-2.454, -2.532],
                                                [0, 0],
                                                [-3.257, -2.972],
                                                [0, 0],
                                                [-2.818, -2.737],
                                                [0, 0],
                                                [-3.212, -3.782],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-1.823, 1.519],
                                                [0, 0],
                                                [-2.302, 1.782],
                                                [0, 0],
                                                [-2.078, 2.416],
                                                [0, 0],
                                                [-1.755, 1.49],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-169.73, -2.398],
                                                [-180, -9.991],
                                                [-180, -29.991],
                                                [-175, -34.991],
                                                [-175, -49.991],
                                                [-165, -59.991],
                                                [-140, -59.991],
                                                [-130, -69.991],
                                                [-100, -69.991],
                                                [-89.916, -60.163],
                                                [-20, -59.991],
                                                [-10, -69.991],
                                                [60, -69.991],
                                                [70, -59.991],
                                                [110, -59.991],
                                                [120, -69.991],
                                                [170, -69.991],
                                                [180, -59.991],
                                                [180, -9.991],
                                                [169.973, -2.398],
                                                [169.973, 2.489],
                                                [169.632, 10.876],
                                                [170.071, 20.009],
                                                [169.974, 29.996],
                                                [169.974, 37.792],
                                                [169.905, 47.125],
                                                [169.905, 56.247],
                                                [169.892, 65.132],
                                                [169.845, 69.991],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [200, 149.991], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 17',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 17,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [5.086, -27.407],
                                                [-5.086, -17.593],
                                                [-5.086, 2.407],
                                                [5.086, 12.216],
                                                [4.914, 27.407],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [25.086, 247.593], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 18',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 18,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-37.62, -4.987],
                                                [-27.61, 5.033],
                                                [-7.628, 4.978],
                                                [2.39, 9.987],
                                                [27.195, 9.987],
                                                [37.234, -0.141],
                                                [37.62, -9.987],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [67.62, 279.987], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 19',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 19,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'tm',
                            s: { a: 0, k: 0, ix: 1 },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 0,
                                        s: [0],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 30,
                                        s: [100],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 50,
                                        s: [100],
                                    },
                                    { t: 70, s: [0] },
                                ],
                                ix: 2,
                            },
                            o: { a: 0, k: 0, ix: 3 },
                            m: 1,
                            ix: 20,
                            nm: 'Pfade trimmen 1',
                            mn: 'ADBE Vector Filter - Trim',
                            hd: false,
                        },
                    ],
                    ip: 0,
                    op: 75,
                    st: 0,
                    bm: 0,
                },
            ],
        },
        {
            id: 'comp_4',
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: 'SEW_Bewegbilder_R-Getriebe_2D Konturen',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-20, -2],
                                                [20, 2],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [80, 194], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 1',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [54, 158],
                                                [60, 158],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 2',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 2,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [20, 10],
                                                [-20, 10],
                                                [-20, -10],
                                                [-14, -10],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [40, 168], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 3',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 3,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [240, 236],
                                                [284, 236],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 4',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 4,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [240, 226],
                                                [284, 226],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 5',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 5,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [240, 216],
                                                [284, 216],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 6',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 6,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [240, 206],
                                                [284, 206],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 7',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 7,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [240, 196],
                                                [284, 196],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 8',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 8,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [240, 186],
                                                [284, 186],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 9',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 9,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [240, 174],
                                                [284, 174],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 10',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 10,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [240, 164],
                                                [360, 164],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 11',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 11,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [240, 154],
                                                [360, 154],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 12',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 12,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [240, 144],
                                                [360, 144],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 13',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 13,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [7, 49.17],
                                                [-7, 49.17],
                                                [-7, -49.169],
                                                [7, -49.169],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [227, 184.905], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 14',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 14,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-3.314, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 3.314],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [8, -8],
                                                [-8, -8],
                                                [-8, 2],
                                                [-2, 8],
                                                [8, 8],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [292, 238], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 15',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 15,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [3.314, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 3.314],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-8, -8],
                                                [8, -8],
                                                [8, 2],
                                                [2, 8],
                                                [-8, 8],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [352, 238], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 16',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 16,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [3.314, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, -3.314],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-8, 8],
                                                [8, 8],
                                                [8, -2],
                                                [2, -8],
                                                [-8, -8],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [352, 178], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 17',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 17,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-3.314, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, -3.314],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [8, 8],
                                                [-8, 8],
                                                [-8, -2],
                                                [-2, -8],
                                                [8, -8],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [292, 178], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 18',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 18,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -3.314],
                                                [3.314, 0],
                                                [0, 3.314],
                                                [-3.314, 0],
                                            ],
                                            o: [
                                                [0, 3.314],
                                                [-3.314, 0],
                                                [0, -3.314],
                                                [3.314, 0],
                                            ],
                                            v: [
                                                [6, 0],
                                                [0, 6],
                                                [-6, 0],
                                                [0, -6],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [112, 242], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 19',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 19,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [154, 210],
                                                [100, 210],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 20',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 20,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [27, -0.001],
                                                [-27, 0.001],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [127, 224.001], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 21',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 21,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 10],
                                            ],
                                            o: [
                                                [0, 0],
                                                [-4, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [13.786, 5],
                                                [-9.786, 5],
                                                [-13.786, -5],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [139.786, 233], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 22',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 22,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 10],
                                            ],
                                            o: [
                                                [0, 0],
                                                [-3.985, -0.016],
                                                [0, 0],
                                            ],
                                            v: [
                                                [13.484, 4.992],
                                                [-9.499, 5.008],
                                                [-13.484, -5.008],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [139.484, 247.008], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 23',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 23,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [25, 8],
                                                [15, -8],
                                                [-25, -8],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [125, 272], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 24',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 24,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [3.498, 0],
                                                [0, 0],
                                                [0, 3.279],
                                                [0, 0],
                                                [-3.498, 0],
                                                [0, 0],
                                                [0, -3.279],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [-3.498, 0],
                                                [0, 0],
                                                [0, -3.279],
                                                [0, 0],
                                                [3.498, 0],
                                                [0, 0],
                                                [0, 3.279],
                                            ],
                                            v: [
                                                [31.667, 38],
                                                [-31.666, 38],
                                                [-38, 32.063],
                                                [-38, -32.063],
                                                [-31.666, -38],
                                                [31.667, -38],
                                                [38, -32.063],
                                                [38, 32.063],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [322, 208], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 26',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 26,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [3.314, 0],
                                                [0, 0],
                                                [0, 2.761],
                                                [0, 0],
                                                [-2.761, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [-2.761, 0],
                                                [0, 0],
                                                [0, -2.761],
                                                [0, 0],
                                                [0, 0],
                                                [0, 3.314],
                                            ],
                                            v: [
                                                [57, 61],
                                                [-58, 61],
                                                [-63, 56],
                                                [-63, -56],
                                                [-58, -61],
                                                [63, -61],
                                                [63, 55],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [297, 185], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 27',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 27,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [5.523, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, -5.523],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [5.523, 0],
                                                [0, 0],
                                                [0, 5.523],
                                            ],
                                            v: [
                                                [-5, 61],
                                                [-5, 61],
                                                [-5, -61],
                                                [5, -51],
                                                [5, 51],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [375, 185], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 28',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 28,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [1.105, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, -1.105],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [1.105, 0],
                                                [0, 0],
                                                [0, 1.105],
                                            ],
                                            v: [
                                                [3, 65],
                                                [-5, 65],
                                                [-5, -65],
                                                [3, -65],
                                                [5, -63],
                                                [5, 63],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [365, 185], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 29',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 29,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0.008, 5.468],
                                                [0, 0],
                                                [-5.521, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [-5.467, -0.065],
                                                [0, 0],
                                                [-0.008, -5.521],
                                                [0, 0],
                                            ],
                                            v: [
                                                [4.997, 49.169],
                                                [4.997, 49.169],
                                                [-4.878, 39.191],
                                                [-4.989, -39.169],
                                                [4.997, -49.169],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [215.003, 184.906], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 30',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 30,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0.008, 5.27],
                                                [0, 0],
                                                [9.946, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [5.269, 0.091],
                                                [0, 0],
                                                [-0.016, -9.946],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-0.521, 44.954],
                                                [-0.521, 44.954],
                                                [9.058, 35.526],
                                                [8.962, -27.046],
                                                [-9.066, -45.046],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [201.066, 185.046], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 31',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 31,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [5.064, -24.569],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [5.725, 33.415],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-22.863, -70],
                                                [27.138, -70],
                                                [27.138, 70],
                                                [-32.863, 70],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [122.862, 210], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 32',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 32,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [1.105, 0],
                                                [0, 0],
                                                [0, 1.105],
                                                [-1.105, 0],
                                                [0, 0],
                                                [0, -1.105],
                                            ],
                                            o: [
                                                [0, 0],
                                                [-1.105, 0],
                                                [0, -1.105],
                                                [0, 0],
                                                [1.105, 0],
                                                [0, 1.105],
                                            ],
                                            v: [
                                                [12, 2],
                                                [-12, 2],
                                                [-14, 0],
                                                [-12, -2],
                                                [12, -2],
                                                [14, 0],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [40, 158], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 33',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 33,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [20, 35],
                                                [-20, 29],
                                                [-20, -29],
                                                [20, -35],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [80, 169], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 34',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 34,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [20.114, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [-0.001, 8],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [47.057, -79.946],
                                                [-22.943, -79.946],
                                                [-22.943, 56.054],
                                                [-47.058, 64.054],
                                                [-46.943, 79.946],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [122.943, 209.946], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 35',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 35,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [0.212, -84.946],
                                                [-0.212, 84.946],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [179.788, 204.946], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 36',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 36,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [4, 0],
                                                [0, 0],
                                                [1.469, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, -4],
                                                [0, 0],
                                                [-0.14, -1.462],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-75, 84.946],
                                                [74.792, 84.946],
                                                [75, 69.054],
                                                [59, 69.054],
                                                [53, 63.054],
                                                [39.247, -82.367],
                                                [36.41, -84.946],
                                                [19, -84.946],
                                                [18.461, 84.946],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [151, 204.946], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 37',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 37,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'tm',
                            s: { a: 0, k: 0, ix: 1 },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 0,
                                        s: [0],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 30,
                                        s: [100],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 50,
                                        s: [100],
                                    },
                                    { t: 65, s: [0] },
                                ],
                                ix: 2,
                            },
                            o: { a: 0, k: 0, ix: 3 },
                            m: 1,
                            ix: 38,
                            nm: 'Pfade trimmen 1',
                            mn: 'ADBE Vector Filter - Trim',
                            hd: false,
                        },
                    ],
                    ip: 0,
                    op: 70,
                    st: 0,
                    bm: 0,
                },
            ],
        },
        {
            id: 'comp_5',
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: 'Kreise',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -3.679],
                                                [3.679, 0],
                                                [0, 3.679],
                                                [-3.679, 0],
                                            ],
                                            o: [
                                                [0, 3.679],
                                                [-3.679, 0],
                                                [0, -3.679],
                                                [3.679, 0],
                                            ],
                                            v: [
                                                [6.661, 0],
                                                [0, 6.661],
                                                [-6.661, 0],
                                                [0, -6.661],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [305.948, 116.337], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 4',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -3.679],
                                                [3.679, 0],
                                                [0, 3.679],
                                                [-3.679, 0],
                                            ],
                                            o: [
                                                [0, 3.679],
                                                [-3.679, 0],
                                                [0, -3.679],
                                                [3.679, 0],
                                            ],
                                            v: [
                                                [6.661, 0],
                                                [0, 6.661],
                                                [-6.661, 0],
                                                [0, -6.661],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [305.948, 93.257], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 5',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 2,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -1.933],
                                                [1.933, 0],
                                                [0, 1.933],
                                                [-1.933, 0],
                                            ],
                                            o: [
                                                [0, 1.933],
                                                [-1.933, 0],
                                                [0, -1.933],
                                                [1.933, 0],
                                            ],
                                            v: [
                                                [3.5, 0],
                                                [0, 3.5],
                                                [-3.5, 0],
                                                [0, -3.5],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [275, 245], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 6',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 3,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -1.933],
                                                [1.933, 0],
                                                [0, 1.933],
                                                [-1.933, 0],
                                            ],
                                            o: [
                                                [0, 1.933],
                                                [-1.933, 0],
                                                [0, -1.933],
                                                [1.933, 0],
                                            ],
                                            v: [
                                                [3.5, 0],
                                                [0, 3.5],
                                                [-3.5, 0],
                                                [0, -3.5],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [275, 255], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 7',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 4,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -1.933],
                                                [1.933, 0],
                                                [0, 1.933],
                                                [-1.933, 0],
                                            ],
                                            o: [
                                                [0, 1.933],
                                                [-1.933, 0],
                                                [0, -1.933],
                                                [1.933, 0],
                                            ],
                                            v: [
                                                [3.5, 0],
                                                [0, 3.5],
                                                [-3.5, 0],
                                                [0, -3.5],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [275, 265], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 8',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 5,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -3.679],
                                                [3.679, 0],
                                                [0, 3.679],
                                                [-3.679, 0],
                                            ],
                                            o: [
                                                [0, 3.679],
                                                [-3.679, 0],
                                                [0, -3.679],
                                                [3.679, 0],
                                            ],
                                            v: [
                                                [6.661, 0],
                                                [0, 6.661],
                                                [-6.661, 0],
                                                [0, -6.661],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [319.536, 105.285], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 9',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 6,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -3.679],
                                                [3.679, 0],
                                                [0, 3.679],
                                                [-3.679, 0],
                                            ],
                                            o: [
                                                [0, 3.679],
                                                [-3.679, 0],
                                                [0, -3.679],
                                                [3.679, 0],
                                            ],
                                            v: [
                                                [6.661, 0],
                                                [0, 6.661],
                                                [-6.661, 0],
                                                [0, -6.661],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [292.36, 105.285], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 10',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 7,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'tm',
                            s: { a: 0, k: 0, ix: 1 },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 20,
                                        s: [0],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 30,
                                        s: [100],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 50,
                                        s: [100],
                                    },
                                    { t: 60, s: [0] },
                                ],
                                ix: 2,
                            },
                            o: { a: 0, k: 0, ix: 3 },
                            m: 1,
                            ix: 8,
                            nm: 'Pfade trimmen 1',
                            mn: 'ADBE Vector Filter - Trim',
                            hd: false,
                        },
                    ],
                    ip: 20,
                    op: 70,
                    st: -10,
                    bm: 0,
                },
                {
                    ddd: 0,
                    ind: 2,
                    ty: 4,
                    nm: 'SEW_Bewegbilder_AGV_2D Konturen',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-70, -35],
                                                [-70, 5],
                                                [-80, 5],
                                                [-80, 35],
                                                [80, 35],
                                                [80, -15],
                                                [50, -15],
                                                [40, -35],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [210, 245], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 3',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [20.049, 80],
                                                [380, 80],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 11',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 2,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-180, 30],
                                                [70, 30],
                                                [90, 40],
                                                [180, 40],
                                                [180, -40],
                                                [-180, -40],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [200, 90], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 12',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 3,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [20.049, 130],
                                                [380, 130],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 13',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 4,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [20, 139.978],
                                                [380, 139.978],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 14',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 5,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [20, 150],
                                                [380, 150],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 15',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 6,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-180, 10],
                                                [180, 10],
                                                [180, 0],
                                                [90, 0.011],
                                                [70, -10],
                                                [-180, -10],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [200, 160], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 16',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 7,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [350, 210],
                                                [350, 170],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 17',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 8,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [50, 210],
                                                [50, 170],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 18',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 9,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [180, -55],
                                                [110, -55],
                                                [100, -65],
                                                [-100, -65],
                                                [-110, -55],
                                                [-180, -55],
                                                [-180, 65],
                                                [-110, 65],
                                                [-100, 55],
                                                [100, 55],
                                                [110, 65],
                                                [180, 65],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [200, 265], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 19',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 10,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [380, 290],
                                                [20, 290],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 20',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 11,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [170, -10],
                                                [169.898, 10],
                                                [-170, 10],
                                                [-170, -10],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [200, 340], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 21',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 12,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-26.772, -7.56],
                                                [-13.228, 7.56],
                                                [26.772, 7.56],
                                                [26.772, -7.56],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [353.227, 352.44], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 22',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 13,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [13.331, 7.56],
                                                [-26.669, 7.56],
                                                [-26.669, -7.559],
                                                [26.669, -7.559],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [46.668, 352.44], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 23',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 14,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'tm',
                            s: { a: 0, k: 0, ix: 1 },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 0,
                                        s: [0],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 30,
                                        s: [100],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 50,
                                        s: [100],
                                    },
                                    { t: 65, s: [0] },
                                ],
                                ix: 2,
                            },
                            o: { a: 0, k: 0, ix: 3 },
                            m: 1,
                            ix: 15,
                            nm: 'Pfade trimmen 1',
                            mn: 'ADBE Vector Filter - Trim',
                            hd: false,
                        },
                    ],
                    ip: 0,
                    op: 70,
                    st: 0,
                    bm: 0,
                },
            ],
        },
        {
            id: 'comp_6',
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: 'SEW_Bewegbilder_Gear_2d_korr Konturen',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-5, 25],
                                                [5, 25],
                                                [5, -25],
                                                [-5, -25],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [325, 305], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 1',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-5, 35],
                                                [5, 35],
                                                [5, -35],
                                                [-5, -35],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [315, 305], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 2',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 2,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -5.381],
                                                [5.381, 0],
                                                [0, 5.381],
                                                [-5.381, 0],
                                            ],
                                            o: [
                                                [0, 5.381],
                                                [-5.381, 0],
                                                [0, -5.381],
                                                [5.381, 0],
                                            ],
                                            v: [
                                                [9.743, 0],
                                                [0, 9.743],
                                                [-9.743, 0],
                                                [0, -9.743],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [159.743, 110], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 3',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 3,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, -5.381],
                                                [5.381, 0],
                                                [0, 5.381],
                                                [-5.381, 0],
                                            ],
                                            o: [
                                                [0, 5.381],
                                                [-5.381, 0],
                                                [0, -5.381],
                                                [5.381, 0],
                                            ],
                                            v: [
                                                [9.743, 0],
                                                [0, 9.743],
                                                [-9.743, 0],
                                                [0, -9.743],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [129.743, 110], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 4',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 4,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [-5.771, -8.678],
                                                [0, 0],
                                                [-22.519, -5.318],
                                                [0, 0],
                                                [0, 0],
                                                [0, 67.047],
                                                [34.417, 3.846],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [-15.633, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 28.855],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, -30.206],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [15.5, 0],
                                            ],
                                            v: [
                                                [70, -160],
                                                [69.916, -60],
                                                [109.916, -20],
                                                [110, 180],
                                                [30, 180],
                                                [10.05, 100],
                                                [-40, 40],
                                                [-110, 40],
                                                [-110, -50],
                                                [-90, -60],
                                                [-90, -100],
                                                [-110, -100],
                                                [-110, -110],
                                                [-100, -110],
                                                [-100, -160],
                                                [-69.968, -180],
                                                [39.916, -179.972],
                                            ],
                                            c: true,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [200, 200], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 5',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 5,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [309.916, 180],
                                                [90, 180],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 6',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 6,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 12.433],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-48.694, -6.217],
                                                [48.694, 3.691],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [138.694, 246.217], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 7',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 7,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 12.222],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [-9.164, -48.711],
                                                [-9.164, 18.206],
                                                [1.134, 48.71],
                                                [9.164, 48.71],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [208.866, 311.289], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 8',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 8,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [2.092, 0],
                                                [2.389, 0],
                                                [2.398, 0],
                                                [2.398, 0],
                                                [2.398, 0],
                                                [2.398, 0],
                                                [2.398, 0],
                                                [2.398, 0],
                                                [2.398, 0],
                                                [2.358, 0],
                                                [2.398, 0],
                                                [2.398, 0],
                                                [2.398, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [-2.761, 0],
                                                [-2.407, 0],
                                                [-2.398, 0],
                                                [-2.398, 0],
                                                [-2.399, 0],
                                                [-2.399, 0],
                                                [-2.399, 0],
                                                [-2.399, 0],
                                                [-2.399, 0],
                                                [-2.439, 0],
                                                [-2.399, 0],
                                                [-2.399, 0],
                                                [-3.395, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [85, 5],
                                                [45.032, -5],
                                                [35.703, -1],
                                                [28.499, -5],
                                                [21.304, -1],
                                                [14.109, -5],
                                                [6.914, -1],
                                                [-0.281, -5],
                                                [-7.476, -1],
                                                [-14.671, -5],
                                                [-21.826, -1],
                                                [-29.061, -5],
                                                [-36.256, -1],
                                                [-45.298, -5],
                                                [-85, 5],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [185, 35], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 9',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 9,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                            ],
                                            v: [
                                                [89.958, -20],
                                                [-89.958, -20],
                                                [-89.958, -10],
                                                [-69.958, -10],
                                                [-69.958, 20],
                                                [89.958, 20],
                                            ],
                                            c: false,
                                        },
                                        ix: 2,
                                    },
                                    nm: 'Pfad 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false,
                                },
                                {
                                    ty: 'st',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 3 },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: { a: 0, k: 3, ix: 5 },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: 'Kontur 1',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [179.958, 110], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transformieren',
                                },
                            ],
                            nm: 'Gruppe 10',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 10,
                            mn: 'ADBE Vector Group',
                            hd: false,
                        },
                        {
                            ty: 'tm',
                            s: { a: 0, k: 0, ix: 1 },
                            e: {
                                a: 1,
                                k: [
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 0,
                                        s: [0],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 20,
                                        s: [100],
                                    },
                                    {
                                        i: { x: [0.833], y: [0.833] },
                                        o: { x: [0.167], y: [0.167] },
                                        t: 40,
                                        s: [100],
                                    },
                                    { t: 55, s: [0] },
                                ],
                                ix: 2,
                            },
                            o: { a: 0, k: 0, ix: 3 },
                            m: 1,
                            ix: 11,
                            nm: 'Pfade trimmen 1',
                            mn: 'ADBE Vector Filter - Trim',
                            hd: false,
                        },
                    ],
                    ip: 0,
                    op: 61,
                    st: 0,
                    bm: 0,
                },
            ],
        },
    ],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 0,
            nm: 'Umrichter',
            refId: 'comp_0',
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
                a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
            },
            ao: 0,
            w: 400,
            h: 400,
            ip: 388,
            op: 463,
            st: 388,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 2,
            ty: 0,
            nm: 'MOVIdrive',
            refId: 'comp_1',
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
                a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
            },
            ao: 0,
            w: 400,
            h: 400,
            ip: 312,
            op: 397,
            st: 312,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 3,
            ty: 0,
            nm: 'MOMVIMOadvanced',
            refId: 'comp_2',
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
                a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
            },
            ao: 0,
            w: 400,
            h: 400,
            ip: 244,
            op: 319,
            st: 244,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 4,
            ty: 0,
            nm: 'IG',
            refId: 'comp_3',
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
                a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
            },
            ao: 0,
            w: 400,
            h: 400,
            ip: 177,
            op: 252,
            st: 177,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 5,
            ty: 0,
            nm: 'R-Getriebe',
            refId: 'comp_4',
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
                a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
            },
            ao: 0,
            w: 400,
            h: 400,
            ip: 115,
            op: 185,
            st: 115,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 6,
            ty: 0,
            nm: 'AGV',
            refId: 'comp_5',
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
                a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
            },
            ao: 0,
            w: 400,
            h: 400,
            ip: 52,
            op: 122,
            st: 52,
            bm: 0,
        },
        {
            ddd: 0,
            ind: 7,
            ty: 0,
            nm: 'GEAR_korr',
            refId: 'comp_6',
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [200, 200, 0], ix: 2, l: 2 },
                a: { a: 0, k: [200, 200, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
            },
            ao: 0,
            w: 400,
            h: 400,
            ip: 0,
            op: 55,
            st: 0,
            bm: 0,
        },
    ],
    markers: [],
};
